import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Colors */
    --primary: #00E676;
    --primary-hover: #00FF7F;
    --primary-dark: #00C853;
    --primary-light: #69F0AE;
    --secondary: #2D3748;
    --text-dark: #E2E8F0;
    --text-light: #FFFFFF;
    --text-muted: #A0AEC0;
    --background: #121212;
    --section-bg: #1A1A1A;
    --card-bg: #1E1E1E;
    --light-gray: #2A2A2A;
    --border-color: #333333;
    
    /* Other variables */
    --border-radius: 12px;
    --shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    --transition: all 0.3s ease;
    --container-width: 1200px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: var(--background);
    color: var(--text-dark);
    line-height: 1.6;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
    color: var(--primary);
    transition: var(--transition);
    
    &:hover {
      color: var(--primary-hover);
    }
  }

  button {
    font-family: inherit;
    cursor: pointer;
  }

  .container {
    width: 100%;
    max-width: var(--container-width);
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(--text-light);
    line-height: 1.3;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 3.5rem;
    font-weight: 700;
    
    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  }

  h2 {
    font-size: 2.5rem;
    font-weight: 600;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  h3 {
    font-size: 2rem;
    font-weight: 600;
    
    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  p {
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  section {
    padding: 5rem 0;
  }
  
  main {
    padding-top: 0; /* Убираем отступ, так как хедер больше не фиксированный */
  }

  ul {
    list-style: none;
  }

  .active {
    color: var(--primary);
  }
`;

export default GlobalStyles;